import { useEffect } from 'react';
import { useFeatureFlags } from './useFeatureFlags';

/**
 * A feature flag that fails CLOSED: `enabled` is false while the flag is
 * loading or could not be resolved, so a gated surface never flashes in
 * before the flag is known. `isLoading` lets a caller hold work (e.g. a query
 * whose shape depends on the flag) until the answer is in.
 */
export function useFailClosedFlag(flagKey: string): {
  enabled: boolean;
  isLoading: boolean;
} {
  const { flags, isLoading, isError } = useFeatureFlags([flagKey]);

  useEffect(() => {
    if (isError) {
      console.error(
        `[useFailClosedFlag] Failed to resolve ${flagKey} feature flag; defaulting to off`
      );
    }
  }, [isError, flagKey]);

  return {
    enabled: !isLoading && !isError && flags[flagKey] === true,
    isLoading,
  };
}
